import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { LEGAL_SLUGS } from "../pages/legal/legalContent";

// Consent foundation. LIVYVIO currently runs NO non-essential tracking (no Google
// Analytics or similar), so this banner stays OFF and renders nothing — showing a
// consent prompt with nothing to consent to would be misleading.
//
// TO ACTIVATE later (when optional analytics is introduced): set the flag below to
// true. Then load any non-essential tracking ONLY after `livyvio_consent === "accepted"`.
export const NON_ESSENTIAL_TRACKING_ENABLED = false;
const CONSENT_KEY = "livyvio_consent";

const T = {
  en: { msg: "We use essential storage to run LIVYVIO. With your consent we may also use optional analytics to improve the site.", accept: "Accept optional", reject: "Reject optional", manage: "Cookie policy" },
  es: { msg: "Usamos almacenamiento esencial para que LIVYVIO funcione. Con tu consentimiento también podemos usar analítica opcional para mejorar el sitio.", accept: "Aceptar opcionales", reject: "Rechazar opcionales", manage: "Política de cookies" },
  nl: { msg: "We gebruiken essentiële opslag om LIVYVIO te laten werken. Met jouw toestemming kunnen we ook optionele analyse gebruiken om de site te verbeteren.", accept: "Optionele accepteren", reject: "Optionele weigeren", manage: "Cookiebeleid" },
};

export function CookieConsent() {
  const { locale, lp } = useLocale();
  const [choice, setChoice] = useState("set");

  useEffect(() => {
    if (!NON_ESSENTIAL_TRACKING_ENABLED) return;
    try { setChoice(localStorage.getItem(CONSENT_KEY) || null); } catch { setChoice(null); }
  }, []);

  if (!NON_ESSENTIAL_TRACKING_ENABLED || choice) return null;

  const decide = (v) => { try { localStorage.setItem(CONSENT_KEY, v); } catch {} setChoice(v); };
  const c = T[locale] || T.en;

  return (
    <div data-testid="cookie-consent" className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 p-4 shadow-lg backdrop-blur">
      <div className="container-page flex flex-col items-start gap-3 sm:flex-row sm:items-center">
        <p className="text-sm text-slate-600">
          {c.msg}{" "}
          <Link to={lp(`/${LEGAL_SLUGS.cookies[locale]}`)} className="font-semibold text-emerald-700 hover:underline">{c.manage}</Link>
        </p>
        <div className="flex shrink-0 gap-2 sm:ml-auto">
          <button onClick={() => decide("rejected")} data-testid="consent-reject" className="rounded-full border border-slate-300 px-4 py-1.5 text-sm font-semibold text-slate-700 hover:bg-slate-50">{c.reject}</button>
          <button onClick={() => decide("accepted")} data-testid="consent-accept" className="rounded-full bg-emerald-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-emerald-700">{c.accept}</button>
        </div>
      </div>
    </div>
  );
}
